import './assets/scss/includes.scss';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import API from '@/api';

Vue.config.productionTip = false;


(async () => {
    const allowedExternalVhosts = ['kiesjerolsteiger.web05.triggerfish-test.nl', 'localhost', 'kiesjerolsteiger.klanten.blueflamingos.nl', 'kiesjerolsteiger.com'];

    const response = await API.get('/settings', {
        params: {
            configuratorHost: allowedExternalVhosts.includes(window.location.hostname) ? "kiesjerolsteiger.com" : window.location.hostname,
        },
    }).catch(() => {
        alert('Er is een fout opgetreden, probeer het later opnieuw.');
    });

    Vue.prototype.$appdata = response.data;

    new Vue({
        router,
        render: (h) => h(App),
    }).$mount('#app');
})();
